import { input, iti } from './intlTelInput'
import * as smartWizard from 'smartwizard'
import 'dirrty/dist/jquery.dirrty.js'
import helpers from './helpers'

const locale = $('#front').data('front-locale')
let $wizardInstance = null
let registrationWizard = {
    preventJump(error = false) {
        setTimeout(function() {
            var menuHeight = $('header').height()

            if (error)
                var scrollTo =
                    $('.hs-popup.has-wizard .has-error')
                        .first()
                        .offset().top -
                    menuHeight -
                    30
            else var scrollTo = $('.hs-popup.has-wizard').offset().top - menuHeight - 30

            $('body,html').animate({ scrollTop: scrollTo }, 100)
        }, 1)
    },
    onLeaveStep(anchorObject, stepNumber, stepDirection) {
        const form = $(`#step-${stepNumber + 1} form`)[0]
        form && form.reportValidity()

        let isValid
        const elmForm = $('.hs-popup.has-wizard #step-' + (stepNumber + 1) + ' .form-section')

        // stepDirection === 'forward' :- this condition allows to do the form validation
        // only on forward navigation, that makes easy navigation on backwards still do the validation when going next
        if (stepDirection === 'forward' && elmForm) {
            elmForm.validator('validate')
            let elmErr = elmForm.children('.has-error')
            isValid = !(elmErr && elmErr.length > 0)
        }

        if (stepDirection === 'forward' && !isValid) {
            registrationWizard.preventJump(error)
        } else {
            registrationWizard.preventJump()
        }

        return isValid
    },

    onShowStep(anchorObject, stepNumber, stepDirection) {
        // Enable finish button only on last step
        if (stepNumber === 4) {
            $('.btn-finish').removeClass('disabled')
            $('.sw-btn-prev').addClass('disabled force-disabled')
            $('.step-anchor li.nav-item').addClass('disabled')
        } else {
            $('.btn-finish').addClass('disabled')
            $('.sw-btn-prev').removeClass('disabled force-disabled')
            $('.step-anchor li.nav-item').removeClass('disabled')
        }

        if (stepNumber === 0) {
            $('.sw-btn-prev').addClass('disabled')
        } else {
            $('.sw-btn-prev').removeClass('disabled')
        }

        registrationWizard.enableButtons()
    },

    submitStep(data, step) {
        $('#registration-loading').removeClass('d-none')
        registrationWizard.disableButtons()

        let result, hasVerifiedPhone

        $.ajax({
            url: route('registrations-user.update', $('#userId').val()),
            method: 'PUT',
            data,
            dataType: 'JSON',
        }).done(responseData => {
            $('#registration-loading').addClass('d-none')

            result = responseData.success

            if (!result) {
                helpers.showRegistrationAlert(
                    `#alert-container-${data.step}`,
                    'danger',
                    responseData.errors.message,
                )
            } else {
                let isPrivate = responseData.step === 4 && responseData.isPrivate
                let isBusiness = responseData.step === 5 && responseData.isBusiness

                if (isPrivate || isBusiness) {
                    const $front = $('#front')

                    // fbq('track', 'CompleteRegistration', {
                    //     value: 9.00,
                    //     currency: $front.data('site-currency')
                    // })
                }

                $(`#step-${step + 1} form`).removeData('should-save')
                $wizardInstance.data('smartWizard')._transitPage(step + 1)
            }

            registrationWizard.enableButtons()
        })

        return result
    },

    openLoginModal() {
        $('.tab-wrap .tab-single.active').removeClass('active')
        $('.tab-content .tab-content-single.active').removeClass('active')
        $('.tab-wrap .tab-single[data-content=0]').addClass('active')
        $('.tab-content .tab-content-single[data-content=0]').addClass('active')

        $('#registration').css('visibility', 'hidden')

        // Subscribe to newsletter
        registrationWizard.newsletter()

        $('#login-register').toggleClass('is-visible')
    },

    init($element, step) {
        let toolbarExtraButtons = $('#registration-wrap #registration').data('is-logged') === 1 ? [
            $('<button></button>')
                .text(Lang.get('javascript.title.enter'))
                .addClass('btn btn-finish text-white')
                .on('click', () => {
                    // Add action for when user finishs the form

                    window.location.href = `/${locale}`
                }),
        ] : [
            $('<button></button>')
                .text(Lang.get('javascript.title.login'))
                .addClass('btn btn-finish text-white')
                .on('click', () => {
                    // Add action for when user finishs the form
                    registrationWizard.openLoginModal()
                }),
        ]

        $wizardInstance = $element.smartWizard({
            selected: step,
            toolbarSettings: {
                toolbarPosition: 'bottom',
                toolbarButtonPosition: 'right',
                showNextButton: true,
                showPreviousButton: true,
                keyNavigation: false,
                anchorSettings: {
                    markDoneStep: true, // add done css
                    markAllPreviousStepsAsDone: true, // When a step selected by url hash, all previous steps are marked done
                    removeDoneStepOnNavigateBack: true, // While navigate back done step after active step will be cleared
                    enableAnchorOnDoneStep: true, // Enable/Disable the done steps navigation
                },
                toolbarExtraButtons: toolbarExtraButtons,
            },
            useURLhash: false,
            showStepURLhash: false,
            backButtonSupport: false,
            lang: {
                next: Lang.get('javascript.title.continue'),
                previous: Lang.get('javascript.title.back'),
            },
        })

        if ($('.hs-popup.has-wizard #step-1').is(':visible')) {
            $('.sw-btn-prev').addClass('disabled')
        } else {
            $('.sw-btn-prev').removeClass('disabled')
        }

        if ($('.sw-container .step-content:last-child').is(':visible')) {
            $('.btn-finish').removeClass('disabled')
            $('.sw-btn-prev').addClass('disabled')
        } else {
            $('.btn-finish').addClass('disabled')
            $('.sw-btn-prev').removeClass('disabled')
        }

        $('.hs-popup.has-wizard form .form-section').each(function() {
            $(this).validator({
                focus: true,
            })
        })

        $('#resend_code').on('click', function() {
            $(this).attr('disabled', 'disabled')
            $('#registration-loading').removeClass('d-none')
            registrationWizard.disableButtons()

            $.ajax({
                url: route('registrations-user.post', $('#userId').val()),
                method: 'POST',
                data: null,
                dataType: 'JSON',
            }).done(responseData => {
                $('#registration-loading').addClass('d-none')

                const result = responseData.success

                if (!result) {
                    helpers.showRegistrationAlert(
                        '#alert-container-2',
                        'danger',
                        responseData.errors.message,
                    )
                } else {
                    $(this).removeAttr('disabled')
                    helpers.showRegistrationAlert(
                        '#alert-container-2',
                        'success',
                        responseData.message,
                    )
                }

                registrationWizard.enableButtons()
            })
        })
    },

    clearErrorsMessages(stepNumber) {
        $(`#alert-container-${stepNumber}`)
            .text('')
            .addClass('d-none')
    },

    execute(step) {
        const $wizard = $('.hs-popup.has-wizard')

        if ($wizard.length) {
            registrationWizard.init($wizard, step)

            $wizard.on('leaveStep', (e, anchorObject, stepNumber, stepDirection) => {
                if (
                    ($($wizard).data('is-private') && stepNumber === 3) ||
                    (!$($wizard).data('is-private') && stepNumber === 4)
                ) {
                    window.location.href = registrationWizard.newsletter_redirect()

                    return false
                }

                const shouldSave = $(`#step-${stepNumber + 1} form`).data('should-save')

                if (stepNumber !== 0 && shouldSave !== undefined && shouldSave === false) {
                    return true
                }

                let validation = registrationWizard.onLeaveStep(
                    anchorObject,
                    stepNumber,
                    stepDirection,
                )

                if (validation !== undefined && !validation) {
                    return false
                } else {
                    let stepData

                    switch (stepNumber) {
                        case 0:
                            stepData = {
                                title: $('#title').val(),
                                firstname: $('#firstname').val(),
                                lastname: $('#lastname').val(),
                                day: $('#day').val(),
                                month: $('#month').val(),
                                year: $('#year').val(),
                                calling_code: iti.getSelectedCountryData().dialCode,
                                phone: $('#phone').val(),
                                country: iti.getSelectedCountryData().name,
                                step: 1,
                            }
                            break
                        case 1:
                            stepData = {
                                phone_code: $('#phone_code').val(),
                                step: 2,
                            }
                            break
                        case 2:
                            stepData = {
                                address1: $('#address1').val(),
                                address2: $('#address2').val(),
                                zip: $('#zip').val(),
                                city: $('#city').val(),
                                // country_id: $('#country_id').val(),
                                join_parent: $('#join_parent').is(':checked'),
                                step: 3,
                            }
                            break
                        case 3:
                            stepData = {
                                company_name: $('#company_name').val(),
                                vat_number: $('#vat_number').val(),
                                step: 4,
                            }
                            break
                    }

                    if (stepDirection === 'forward' && stepData) {
                        const data = {
                            ...stepData,
                        }
                        registrationWizard.submitStep(data, stepNumber)

                        return false
                    }
                }

                return true
            })

            $wizard.on('showStep', function(e, anchorObject, stepNumber, stepDirection) {
                if (
                    ($($wizard).data('is-private') && stepNumber === 3) ||
                    (!$($wizard).data('is-private') && stepNumber === 4)
                ) {
                    $('.sw-btn-prev').text(Lang.get('javascript.title.enter'))
                }

                if (stepDirection === 'backward') {
                    $(`#step-${stepNumber + 1} form`)
                        .dirrty({
                            preventLeaving: false,
                        })
                        .on('dirty', function() {
                            $(this).data('should-save', true)
                        })
                        .on('clean', function() {
                            $(this).data('should-save', false)
                        })
                        .data('should-save', false)
                }

                registrationWizard.clearErrorsMessages(stepNumber)
                registrationWizard.onShowStep(anchorObject, stepNumber, stepDirection)
            })

            $wizardInstance.data('smartWizard')._transitPage(step)
        }
    },

    enableButtons() {
        $('.sw-toolbar button').removeAttr('disabled')
    },

    disableButtons() {
        $('.sw-toolbar button').attr('disabled', true)
    },

    newsletter() {
        let subscribe = $('#subscribe_newsletter')
        let newsletter = {
            subscribeToNewsletter: subscribe.is(':checked'),
        }
        if (subscribe.is(':checked')) {
            $.ajax({
                url: route('registrations-user.newsletter', $('#userId').val()),
                method: 'POST',
                newsletter,
                dataType: 'JSON',
            })
        }

    },

    newsletter_redirect() {
        let subscribe = $('#subscribe_newsletter')
        let link = `/${locale}`
        if (subscribe.is(':checked')) {
            link = route('registrations-user.newsletter-redirect', [locale, $('#userId').val()])
        }
        return link
    },
}

registrationWizard.execute($('#steps').data('current-step') - 1)

input &&
input.addEventListener('countrychange', function() {
    const data = iti.getSelectedCountryData()
    // const selectElm = $('#country_id').data('select')
    const inputElm = $('#country_name')

    // selectElm.val($(`option[data-country-code="${data.iso2}"]`).val())
    inputElm.val(data.name)
})
